import { FC, memo } from 'react';
import { AgentInfo } from '../../interfaces/agent';
import { Avatar, AvatarProps } from '../ui/avatar';

interface AgentAvatarProps extends Omit<AvatarProps, 'src'> {
  agent: AgentInfo;
}

const AgentAvatar: FC<AgentAvatarProps> = ({ agent, ...props }) => {
  const status = agent?.status;
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Avatar {...props} src={agent?.avatar} />
      {status && (
        <span
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: status === 1 ? '#43E453' : '#B3B3B3',
            border: '2px solid #fff',
            boxSizing: 'border-box',
            display: 'block',
            boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.10)',
          }}
        />
      )}
    </div>
  );
};
export default memo(AgentAvatar);
